import { IActivity, IAPIActivityAttributes } from '../interface/IActivityList'

export const activityListTransformer = (activityAttributes: IAPIActivityAttributes): IActivity => (
  {
    id: activityAttributes.id,
    name: activityAttributes.name,
    color: activityAttributes.color,
    categoryId: activityAttributes.category_id,
    activityUuid: activityAttributes.uuid,
    image: activityAttributes.image,
    numberOfPersons: activityAttributes.number_of_persons || 1,
  }
)
